import {
  FormControl,
  FormHelperText,
  MenuIdetailsDatatem,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plus.svg";
import { ReactComponent as DropdownIcon } from "../../../assets/icons/arrow-down.svg";
import {
  addDeviceAsync,
  editDeviceAsync,
  fetchDeviceDetailsAsync,
} from "../../../redux/reducers/devicesSlice";
import { useDispatch, useSelector } from "react-redux";
import "./addDevice.css";
import Toast from "../../../components/toast/toast";
import { adminTexts } from "../../../utils/constants";
import { ReactComponent as BackBtn } from "../../../assets/icons/arrow-down.svg";

const AddDevice = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { deviceDetails, isError } = useSelector((state) => ({
    deviceDetails: state?.deviceData?.selectedDevice,
    isError: state?.deviceData?.isError,
  }));

  const [deviceData, setDeviceData] = useState({
    name: "",
    description: "",
    sku: "",
    price: "",
    device_type: "",
  });
  const [toast, setToast] = useState(false);

  const deviceDetailsFields = [
    {
      label: "Device Name",
      name: "name",
      placeholder: "Enter plan name",
      type: "text",
      maxLength: 50,
    },
    {
      label: "SKU",
      name: "sku",
      placeholder: "Enter SKU number",
      type: "text",
      maxLength: 25,
    },
    {
      label: "Price",
      name: "price",
      placeholder: "Enter price here",
      type: "number",
    },
  ];

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (id) {
      dispatch(fetchDeviceDetailsAsync(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (deviceDetails && id) {
      setDeviceData({
        name: deviceDetails.name || "",
        description: deviceDetails.description || "",
        sku: deviceDetails.sku || "",
        price: deviceDetails.price || "",
        device_type: deviceDetails.device_type || "",
      });
    }
  }, [deviceDetails, id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "price") {
      if (/^\d{0,7}(\.\d{0,2})?$/.test(value) || value === "") {
        setDeviceData((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    } else {
      setDeviceData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmitPlan = () => {
    setToast(false);
    if (validateForm() && id) {
      dispatch(editDeviceAsync({ id, updatedData: deviceData })).then((res) => {
        setToast({ header: res?.payload?.message });
        dispatch(fetchDeviceDetailsAsync(id));
      });
    } else if (validateForm()) {
      dispatch(addDeviceAsync(deviceData)).then((res) => {
        setDeviceData({
          name: "",
          description: "",
          sku: "",
          price: "",
          device_type: "",
        });
        setToast({ header: res?.payload?.message });
      });
    }
  };

  const validateForm = () => {
    let isValid = true;
    let validationErrors = {};

    // Validate general fields
    Object.keys(deviceData)?.forEach((field) => {
      if (
        !deviceData[field] &&
        field !== "device_type" &&
        field !== "description"
      ) {
        validationErrors[field] = "This field is required";
        isValid = false;
      }
    });

    setErrors(validationErrors);
    return isValid;
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="add-device-container">
      <div className="previous-page" onClick={handleBack}>
        <BackBtn className="back-btn" />
        <p>Back</p>
      </div>
      <h1 className="title">{id ? "Edit Device" : "Add Device"}</h1>

      {/* Plan Details Form */}
      <div className="form-grid plan-details">
        {deviceDetailsFields.map((field, index) => (
          <div key={index} className="field-group">
            <label className="input-label">{field.label}</label>
            <input
              type={field.type}
              name={field.name}
              value={deviceData[field.name]}
              onChange={handleInputChange}
              placeholder={field.placeholder}
              className="input"
              maxLength={field?.maxLength}
            />
            {errors[field.name] && (
              <FormHelperText className="error-text" error>
                {errors[field.name]}
              </FormHelperText>
            )}
          </div>
        ))}

        <FormControl fullWidth className="custom-select-container">
          <label id="device-type-label">Device Type</label>
          <Select
            labelId="device-type-label"
            name="device_type"
            value={deviceData.device_type}
            onChange={handleInputChange}
            className="input custom-select"
            IconComponent={() => <DropdownIcon />}
            displayEmpty
            renderValue={(selected) =>
              selected || <span className="placeholder">Select Device</span>
            }
          >
            <MenuItem value="DEVICE">DEVICE</MenuItem>
            <MenuItem value="TABLET">TABLET</MenuItem>
          </Select>
          {errors.device_type && (
            <FormHelperText className="error-text" error>
              {errors.device_type}
            </FormHelperText>
          )}
        </FormControl>

        <FormControl
          fullWidth
          className="textarea-container"
          error={Boolean(errors.description)}
        >
          <label className="input-label">Description</label>
          <textarea
            name="description"
            maxLength={250}
            placeholder="Enter description here"
            rows={5}
            className="create-textarea"
            value={deviceData.description}
            onChange={handleInputChange}
          />
          {errors.description && (
            <FormHelperText sx={{ marginLeft: "0" }}>
              {errors.description}
            </FormHelperText>
          )}
        </FormControl>
      </div>
      {toast && !isError && <Toast toast={toast} />}
      <button onClick={handleSubmitPlan} className="add-plan-button">
        Submit
      </button>
      {isError && <p className="error">{adminTexts.error_message} </p>}
    </div>
  );
};

export default AddDevice;
